import { render, staticRenderFns } from "./CashCollectionBK.vue?vue&type=template&id=112ddf6c&scoped=true"
import script from "./CashCollectionBK.vue?vue&type=script&lang=js"
export * from "./CashCollectionBK.vue?vue&type=script&lang=js"
import style0 from "./CashCollectionBK.vue?vue&type=style&index=0&id=112ddf6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112ddf6c",
  null
  
)

export default component.exports